import React from "react";
import SyncBlockList from "./components/SyncBlockList";

export default () => <SyncBlockList />;
